import { differenceInDays, isAfter } from 'date-fns';
import React from 'react';
import { StyleSheet } from 'react-native';
import { CardView, CollapsableContainer, rem } from 'design-system';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import { formatPlural } from 'utils';
import AccountsList from '../AccountsList';
import BankNameRow from '../BankNameRow';
const getDaysLeftColor = (days, isExpired, colors) => {
    if (isExpired)
        return colors.text.statusNegative;
    if (days <= 10)
        return colors.text.statusInformational;
    return colors.elements.secondary;
};
const ConnectionExpiryInfoCard = ({ connection }) => {
    const colors = useColors();
    const days = connection.consentExpiresAt ? differenceInDays(new Date(connection.consentExpiresAt), new Date()) : null;
    const isExpired = connection.consentExpiresAt ? isAfter(new Date(), connection.consentExpiresAt) : false;
    return (<CardView noMarginTop>
      <CollapsableContainer titleContent={<BankNameRow data={connection.bankInfo}/>} isCollapsedByDefault collapsable={connection.accounts.length > 0} rightContent={days !== null ? (<Text {...(days <= 10 ? { 'Text-14': true } : { 'TextThin-14': true })} color={getDaysLeftColor(days, isExpired, colors)} style={styles.daysLeft}>
              {isExpired ? 'Expired' : `${days} ${formatPlural('day', 'days', days)} left`}
            </Text>) : null}>
        <AccountsList accounts={connection.accounts}/>
      </CollapsableContainer>
    </CardView>);
};
const styles = StyleSheet.create({
    daysLeft: {
        alignSelf: 'center',
        marginRight: rem(8),
    },
});
export default React.memo(ConnectionExpiryInfoCard);
